<template>
    <div id="app">
        <div>
            <transition :name="transition">
                <router-view :key="$route.fullPath" class="view container has-padding"/>
            </transition>
        </div>
        <message-list/>
    </div>
</template>

<script>
    import MessageList from './components/MessageList';

    export default {
        name: "app",
        data() {
            return {
                transition: "slide-left"
            }
        },
        watch: {
            $route(toRoute, fromRoute) {
                const toDepth = toRoute.name === 'login' ? -1 : toRoute.path.split('/').length;
                const fromDepth = fromRoute.name === 'login' ? -1 : fromRoute.path.split('/').length;
                this.transition = toDepth < fromDepth ? "slide-right" : "slide-left";
            }
        },
        components: {
            MessageList
        }
    }
</script>